import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { WorkflowBasic } from '@shared-interfaces/shared-workflow';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'shared-new-contract-dialog',
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        FormsModule,
        TranslateModule
    ],
    templateUrl: './new-contract-dialog.component.html',
    styleUrl: './new-contract-dialog.component.css'
})
export class NewContractDialogComponent {
    dialog = inject(MatDialogRef);

    constructor(
        public dialogRef: MatDialogRef<NewContractDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: WorkflowBasic
    ) { }

    onSave(): void {
        this.dialogRef.close();
    }
}
